
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/psr-licence-number",
      function () {
        return require("private-next-pages/psr-licence-number.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/psr-licence-number"])
      });
    }
  